import { BreadCrumb, Navbar } from '../molecule';

const DefaultPage = (props) => {
    const { pathname, links, fluid } = props;
    return (<>
        <Navbar pathname={pathname} />
        <div style={{ height: 56 + 12 }} />
        <div className={`container${fluid ? "-fluid" : ""}`}>
            <BreadCrumb links={links} />
            {props.children}
            <br />
        </div>
    </>);
}

export { DefaultPage };
